/*
 * File: \src\util\default-api.js
 * File Created: 2022-03-31 15:17:34
 * Author: Li Haifeng
 * -----
 * Last Modified: 2022-06-21 16:21:34
 * Modified By: lihf14
 */
export default [
  ["MideaUser", "getUser"],
  ["MideaUser", "isLogin"],
  ["MideaUser", "getUserPassword"],
  ["MideaUser", "toLogin"],
  ["MideaUser", "login"],
  ["MideaUser", "savePw"],
  ["MideaUser", "orgMuChoose"],
  ["MideaUser", "vcard"],
  ["MideaUser", "getContact"],

  ["MideaCommon", "logout"],
  ["MideaCommon", "authPassword"],
  ["MideaCommon", "getH5Info"],
  ["MideaCommon", "saveH5Info"],
  ["MideaCommon", "getMessageUnread"],
  ["MideaCommon", "getExtra"],
  ["MideaCommon", "showSetView"],
  ["MideaCommon", "showMyView"],
  ["MideaCommon", "showAppView"],
  ["MideaCommon", "startApp"],
  ["MideaCommon", "showWidget"],
  ["MideaCommon", "selectWidget"],
  ["MideaCommon", "exit"],
  ["MideaCommon", "openSysBrowser"],
  ["MideaCommon", "openUrl"],
  ["MideaCommon", "gotoSystemSetting"],
  ["MideaCommon", "openServiceNo"],
  ["MideaCommon", "language"],
  ["MideaCommon", "showNav"],
  ["MideaCommon", "hideNav"],
  ["MideaCommon", "showMenu"],
  ["MideaCommon", "showInput"],
  ["MideaCommon", "hideInput"],
  ["MideaCommon", "toggleInput"],
  ["MideaCommon", "showFloat"],
  ["MideaCommon", "hideFloat"],
  ["MideaCommon", "statusBarColor"],
  ["MideaCommon", "copy"],
  ["MideaCommon", "paste"],
  ["MideaCommon", "apk"],
  ["MideaCommon", "callPhone"],
  ["MideaCommon", "webview"],
  ["MideaCommon", "getBase64s"],
  ["MideaCommon", "onEvent"],
  ["MideaCommon", "setBounces"],
  ["MideaCommon", "videoRecord"],
  ["MideaCommon", "saveToGallery"],
  ["MideaCommon", "getPicture"],
  ["MideaCommon", "updateTabUnread"],
  ["MideaCommon", "orientation"],
  ["MideaCommon", "shake"],
  ["MideaCommon", "shakeStop"],
  ["MideaCommon", "showShare"],
  ["MideaCommon", "chatMessage"],
  ["MideaCommon", "chat"],
  ["MideaCommon", "isDarkTheme"],
  ["MideaCommon", "navigationRightButtons"],
  ["MideaCommon", "statusBarColor4Android"],

  ["MideaBarcode", "getScanExtra"],
  ["MideaBarcode", "buildQRcodeImage"],
  ["MideaBarcode", "scan"],

  ["MideaMap", "startUpdatingLocation"],
  ["MideaMap", "stopUpdatingLocation"],
  ["MideaMap", "location"],
  ["MideaMap", "requestLocation"],
  ["MideaMap", "getPois"],
  ["MideaMap", "navTo"],
  ["MideaMap", "navToWithFrom"],

  ["MideaPdf", "showPdf"],

  ["Organization", "orgSelector"],
];
